import React from 'react';
import StopOperationPage from './../components/MobileDailyOperation/StopOperations/StopOperationPage';

const StopOperation = ({ selectedDate }) => {
  return (
    <div>
      <StopOperationPage selectedDate={selectedDate} />
    </div>
  );
};

export default StopOperation;
